import useSWR from 'swr';
import { getFlyerDataForStore } from '@api/interfaces/storeApi';

const useStoreFlyerData = (storeId: string | undefined) => {
  const { data, isLoading } = useSWR(
    storeId ? { endpoint: `/axfood/rest/v1/storeflyer/${storeId}`, storeId } : null,
    getFlyerDataForStore
  );

  return { storeFlyerData: data, isLoading };
};

export default useStoreFlyerData;
